import AddedQuestionsList from "pages/ManagementPage/questionSection/AddedQuestionsList/AddedQuestionsList";

export default AddedQuestionsList;
